<template>
    <span>
        <template v-if="minValue || maxValue">
            <currency :value="minValue" currency=""></currency>
            <template v-if="minValue != maxValue"> {{ separator }} <currency :value="maxValue" currency=""></currency></template>
            <span v-if="currency">{{ currency }}</span>
        </template>

        <template v-if="!minValue && !maxValue">
        -
        </template>
    </span>
</template>

<script>
    export default {

        props: {
            minValue: {
                type: Number|String,
                required: true
            },
            maxValue: {
                type: Number|String,
                required: false,
                default: 0
            },
            currency: {
                type: String,
                required: false,
                default: '€'
            },
            separator: {
                type: String,
                required: false,
                default: '-'
            }
        }
    }
</script>
